import { Toaster } from "@/components/ui/toast/Toaster";

/**
 * ToastProvider — mounts sonner Toaster portal.
 * Placed as a sibling to RouterProvider in main.tsx so it renders
 * outside all route stacking contexts.
 */
export function ToastProvider() {
  return <Toaster />;
}
